import React, {createRef} from 'react'
import { Translation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import Parent from '../../../common/parent';
import ReportsToolBar from "../reports_tool_bar/reportsToolBar";
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import SingleMonthTable from "../table/singleMonthTable";
import { constants } from "../../../common/constants/constants";


class MonthlyChequeTable extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.cheque_report');
        this.printSectionRef = createRef();

        const {t} = props;
        let monthsTexts = this.getSelectMonthForDropdown(props);

        BllinkLogger.info(`this.props.match.params for MonthlyChequeTable`, this.props.match.params)
        this.state = {
            monthInt: parseInt(props.match.params.month),
            headerNames: [
                {name: t('reports.apartmentName'), dataType: 'string'},
                {name: t('reports.tenantName'), dataType: 'string'},
                {name: t('reports.total_to_pay'), dataType: 'numberWithCommas'},
                {name: t('reports.date_to_pay'), dataType: 'string'},
                t('reports.payment_for'),
                t('reports.payment_comment'),
                {name: t('payments.confirmation_id'), dataType: 'string'},
                t('payments.payment_method'),
            ],
            rowsFields: [
                {functionName: 'renderApartmentLink', fieldName:'ApartmentNumber'},
                'ClientName',
                {functionName: 'parseAmount', fieldName:'Amount'},
                {functionName: 'parseDate', fieldName:'PaymentDate'},
                {functionName: 'renderMonthsComment', fieldName: 'months', functionName2: 'renderOneTimeComment', fieldName2: 'oneTime'},
                {functionName: 'shortenText', fieldName: 'Comment'},
                'confirmationID',
                {functionName: 'renderPaymentMethod', fieldName: 'Method'},
            ],
            monthsTexts: monthsTexts,
            rowLevelConditions: [
                {functionName: 'colorRowInRed', fieldName:'PaymentState', classes: 'red-row'},
            ]
        }

        this.onMonthChangedFunc = this.onMonthChanged.bind(this);
        this.tableTitle.bind(this);
    }

    async componentDidMount(){
        BllinkLogger.info(`componentDidMount cheque`, this.props.match.params)
        this.makeFullScreen();
        await this.verifyLoggedIn();

        await this.loadNewMonth(
            this.props.match.params.buildingID,
            this.props.match.params.year,
            this.props.match.params.month
        );
        this.bindTablesQuickSearch();
    }

    async onMonthChanged(newMonthAndYearSelected){

        let parts = newMonthAndYearSelected.split('_');
        let newYear = parts[1];
        let newMonth = parts[0];
        const buildingID = this.props.match.params.buildingID;
        // data-excel-title attribute is sticky without reloading tried for over 2 hours. fallback to page refresh
        window.location.href = `/${constants.pages.monthlyChequesUrl}/${buildingID}/${newMonth}/${newYear}`
        // this.props.history.push(`/${constants.pages.monthlyCashFlowUrl}/${buildingID}/${newMonth}/${newYear}`)

        await this.loadNewMonth(buildingID, newYear, newMonth);
    }


    async loadNewMonth(buildingID, year, month){
        this.startLoader();
        const result = await this.fetchMonthlyCashFlow(
            buildingID,
            year,
            month
        );
        if (result.paymentResults) {
            let rows = result.paymentResults;
            let totalAmount = result.TotalInCheque;
            // let totalAmountInCreditCard = result.TotalInCreditCard;
            let totalAmountInCheques = result.TotalInCheque;
            BllinkLogger.info(`MonthlyChequeTable rows are `, rows);
            rows = rows.filter(row=>{return row.isChequePayment});
            rows = rows.sort(this.sortApartmentNumbersForTable);
            let newExcelTitle = await this.excelReportTitle(buildingID, year, totalAmount, month);
            this.setState({
                loaded: true,
                rows: rows,
                totalAmount: totalAmount,
                // totalAmountInCreditCard: totalAmountInCreditCard,
                totalAmountInCheques: totalAmountInCheques,
                monthInt: parseInt(month),
                excelReportTitle: newExcelTitle
            })
        }
        this.endLoader();
    }

    async excelReportTitle(buildingID, year, totalAmount, month){
        const title = await this.buildingTitleText(buildingID)
        return title + ' - ' + this.tableTitle(year, totalAmount, month);
    }


    render() {

        this.setBodyClasses([constants.backgroundOptions.cashflow_monthly, constants.backgroundOptions.report]);
        const buildingID = this.props.match.params.buildingID;
        const year = this.props.match.params.year;
        const month = this.props.match.params.month;
        const tableTitle = this.tableTitle(year, this.state.totalAmountInCheques, month, {}, 'cheque');

        const shouldLoadEmpty = (!this.state.userCheck || !this.state.loaded)
        if (shouldLoadEmpty){
            return (<div className="div-buffer-empty-content"/>)
        }

        BllinkLogger.info(`rendering monthly cashflow table main `, this.state)

        return (
            <Translation>{(t, {_}) =>
                <section className='mt-5'>
                    <ReportsToolBar
                        options={this.state.monthsTexts}
                        onChange={this.onMonthChangedFunc}
                        defaultValue={`${this.state.monthInt}_${year}`}
                        pdfContainer={this.printSectionRef}
                        isTableEmpty={!this.state.rows.length}
                    />
                    <div id="section-to-print" ref={this.printSectionRef}>
                        <SingleMonthTable
                            title={tableTitle}
                            rows={this.state.rows || []}
                            tableType={"monthlyCashflow"}
                            excelReportTitle={this.state.excelReportTitle}
                            buildingID={buildingID}
                            headerNames={this.state.headerNames}
                            fields={this.state.rowsFields}
                            columns={10}
                            rowLevelConditions={this.state.rowLevelConditions}
                        />
                    </div>
                </section>
            }</Translation>
        )
    }
}


export default withTranslation()(MonthlyChequeTable)
